<template>
   <div class="user_profile_wrap mobile_profile">
        <div class="title">{{get_local_string.string_44}}</div>
        <form @submit.prevent="getMobile_num()"  class="active_code" v-if="step==1">
                        <!-- <input type="text" class="uk-input" name="" id="phone"> -->
                        <div class="text-center phone_wrap">
                             <vue-tel-input @validate="ok($event)" @input="keys()" autocomplete="off"  v-model="phone" ></vue-tel-input>
                             <span :class="{ correct: valid }" class="valid_span">{{this.msg_valid}}</span>
                        </div>
                        <div class="text-left mg-top">
                            <b-button :loading="isLoading" :disabled="!valid" class="yes" type="is-success" native-type="submit"><i class="fas fa-sms"></i> <span>{{get_local_string.string_63}}</span></b-button>
                        </div>
        </form>
        <form @submit.prevent="checkCode()"  class="active_code" v-if="step==2">
                        <div class="d-flex mb-3">
                             <b-field label="Sms code" label-position="on-border">
                                <b-input type="number" v-model="sms_code"   @keyup.native="on_write_sms()" maxlength="6"></b-input>
                            </b-field>
                        </div>
                        <div class="text-left">
                            <b-button class="yes" :disabled="check_code_disable" :loading="isLoading" native-type="submit" type="is-success"><i class="fas fa-sms"></i> <span>{{get_local_string.string_64}}</span></b-button>
                        </div>
                      </form>

   </div>
</template>
<script>
import $ from 'jquery';
import { mapActions,mapGetters, mapMutations } from 'vuex';
export default {
    name:'mobileprofile',
    data(){
        return{
            phone:'',
           valid:null,
           msg_valid:'',
           isLoading: false,
           step:1,
           sms_code:'',
           check_code_disable:true
        }
    },
    computed:{
        ...mapGetters({
         user:'auth/user',
         get_local_string:'get_local_string'
    }),
     ...mapMutations({
           SET_USER:'auth/SET_USER'
       }),
    },
    methods:{
        ...mapActions({
        getMobileNumber:'getMobileNumber',
         activeSms:'activeSms',
        }),
        getMobile_num(){
            // console.log('call get mobile')
           this.isLoading = true;
           let pasrse =this.phone.replace(/\s/g, ""); 
           this.getMobileNumber(pasrse).then(()=>{
               this.isLoading = false
            //    this.$router.replace('/ActiveCode');
             $('.active_code input').val('');
            this.step = 2;
            this.errorMsg = 'The code has been sent successfully '
            this.success();
           }).catch(()=>{
               this.isLoading = false
            //    this.$router.replace('/ActiveMobile');
             this.step = 1;
             this.errorMsg = 'An error occurred, please try again'
            this.danger();
            //  console.log('still step 1')
           });
       },
       keys(){
           if(this.phone== '')
           {
               this.msg_valid = '';
           }
       },
       ok(event){
           if(event.valid == false || event.valid == undefined && this.valid != null){
               this.msg_valid = 'Number is Invalid !';
               this.valid = event.valid;
           }
           else if(event.valid == true)
           {
               this.msg_valid = 'Number is valid !';
               this.valid = event.valid;
           }
       },
    //    start sms code form step 2

    checkCode(){
           this.isLoading = true;
            this.activeSms(this.sms_code).then(()=>{
            // console.log(this.$store.state.res_sms.data.data.code);
            if(this.$store.state.res_sms.status == 401)
            {   
                this.isLoading = false;
                this.errorMsg = 'The code entered is incorrect, try again';
                this.step = 2;
                 this.danger();
            }
            else if(this.$store.state.res_sms.status == 200 ){
                 this.isLoading = false;
                 this.errorMsg = 'The number has been updated successfully';
                 $('.active_code input').val('');
                 this.step = 1
                 this.success();
            }
            })
       
       },
       on_write_sms(){
           if(this.sms_code.length < 6 || this.sms_code.length > 6){
               this.check_code_disable = true;
           }
           else{
               this.check_code_disable = false;
           }
       },
        // MSG ALERT
        success() {
          const notif = this.$buefy.notification.open({
              duration: 4000,
              message: this.errorMsg,
              position: 'is-bottom-right',
              type: 'is-success',
              hasIcon: true
          })
          notif.$on('close', () => {
              // this.$buefy.notification.open('Custom notification closed!')
          }
          )
      },
        danger() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
    }
}
</script>


<style lang="scss">
.vti__dropdown {
    background-color: white !important;
}
.active_code{
    .field{
        width: 100%;
    }
    input:focus{
        border-color: var(--active_color);
    }
    /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
}
</style>
<style lang="scss" scoped>
.user_profile_wrap{
.title{
    font-size: 30px;
    position: relative;
    display: inline-block;
    padding-top: 10px;
    color: var(--active_color);
    border-bottom: 3px solid var(--active_color);
    padding-bottom: 6px;
    }
}
.felx_ok a.no {
    background-color: #f50057;
}
.phone_wrap{
    position: relative;
}
.valid_span{
    color: #f50057;
    position: absolute;
    left: 0px;
    top: 45px;
    font-size: 13px;
    font-weight: 600;

}
.valid_span.correct{
    color: #02bfa6;
}
.mg-top{
    margin-top: 40px;
}
</style>